import { utcToJSDate } from "@/utils/date-time";
import { PaginationFilterRequest } from "./core.model";
import { UserLookup } from "./user.model";

export function templateFromJson(json: any): AdvanceShareTemplate {
  return {
    ...json,
    createdAt: utcToJSDate(json.createdAt)!,
  } as AdvanceShareTemplate;
}

export function templateListFromJson(json: any): AdvanceShareTemplateList {
  return {
    ...json,
    createdAt: utcToJSDate(json.createdAt)!,
  } as AdvanceShareTemplateList;
}

export interface AdvanceShareTemplate {
    id: number;
    name: string;
    userId: number;
    user?: UserLookup;
    version: number;
    status: AdvanceShareTemplateStatusEnum;
    bookmarkCount: number;
    /** Price in points. Null or undefined means the template is free. */
    price?: number;
    createdAt: Date;
    documentJson: string;
}

export interface AdvanceShareTemplateList {
    id: number;
    name: string;
    userId: number;
    user?: UserLookup;
    version: number;
    status: AdvanceShareTemplateStatusEnum;
    bookmarkCount: number;
    /** Price in points. Null or undefined means the template is free. */
    price?: number;
    createdAt: Date;
}

export interface AdvanceShareTemplateDesign {
    aspectRatio: number;
    coverImageUrl?: string;
}

export class AdvanceShareTemplatePaginationFilterRequest extends PaginationFilterRequest {
    userId?: number;
    status?: AdvanceShareTemplateStatusEnum;
}

export enum AdvanceShareTemplateStatusEnum {
    Draft = 1,
    Published = 2,
    Archived = 3,
}

export const AdvanceShareTemplateStatusList =
[
    { value: 1, label: "Draft" },
    { value: 2, label: "Published" },
    { value: 3, label: "Archived" },
];
